/**
 * @file homepage carousel banner
 * 
 * @author Todd Li <tli@squiz.pl>
 * @date March 2019
 */

(function($){
  'use strict';

  if($('.tiles__item').length > 3) {
    $('.tiles__item').addClass('swiper-slide');
    var ieUser = /MSIE \d|Trident.*rv:/; // IE user agent regex
    var slidesPerViewValue;

    ieUser.test(navigator.userAgent)
      ? slidesPerViewValue = 3 // for IE
      : slidesPerViewValue = 'auto'; // for everyone else
    var homepageProgramCarousel = new Swiper ('.swiper-container', {
      direction: 'horizontal',
      loop: false,
      spaceBetween: 20,
      speed: 600,
      slidesPerView: slidesPerViewValue,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.tiles__next',
        prevEl: '.tiles__prev',
      }
    });
  }
}(jQuery));